import { Component, ContentChildren, ElementRef, Input, QueryList, TemplateRef } from '@angular/core';

/**
 * Option menu that supports edit and remove menu items.
 * When any of the menu item is clicked, the event type is emitted to be handled outside the menu.
 * Menu icon is clicked for opening / closing the menu.
 * Menu is automatically being closed if user clicks on any item or outside the menu.
 *
 * @export
 * @class OptionMenuComponent
 * @implements {OnInit}
 */
@Component({
	selector: 'ac-option-menu',
	templateUrl: './option-menu.component.html',
	styleUrls: ['./option-menu.component.scss']
})
export class OptionMenuComponent {

	@ContentChildren(TemplateRef) public itemRefs: QueryList<TemplateRef<any>>; // so that you can wrap each item with a div
	@Input() public iconType: string = 'ellipsis-v';

	public showOptionMenu: boolean = false;
	// Checks if the menu is coming from outside the component and hides the option menu.
	private readonly clickOutsideEventHandler = (event: Event) => {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.showOptionMenu = false;
		}
	};

	constructor(private elementRef: ElementRef) { }

	/**
	 * Toggles the option menu.
	 *
	 */
	public toggleOptionMenu(): void {
		this.showOptionMenu = !this.showOptionMenu;
		if (this.showOptionMenu) {
			document.addEventListener('click', this.clickOutsideEventHandler);
		} else {
			document.removeEventListener('click', this.clickOutsideEventHandler);
		}
	}
}
